import { render } from "./odn-modal-project-procedures-filters.vue?vue&type=template&id=796740a5"
import script from "./odn-modal-project-procedures-filters.vue?vue&type=script&lang=js"
export * from "./odn-modal-project-procedures-filters.vue?vue&type=script&lang=js"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__